import { jsx as p } from "react/jsx-runtime";
import { Children as i, cloneElement as l } from "react";
import { Container as c } from "./styles.js";
const d = ({
  onChange: e,
  value: o,
  children: t,
  className: n
}) => {
  const m = i.map(
    t,
    (r) => l(r, {
      selected: r.props.value === o,
      onChange: e
    })
  );
  return /* @__PURE__ */ p(c, { className: n, children: m });
};
export {
  d as ViewButtonGroup
};
//# sourceMappingURL=ViewButtonGroup.js.map
